import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionLabel } from "./Shared";
import { IMAGES, LOCATIONS } from "../config/siteConfig";
import { viewportOnce } from "../lib/motion";

export const GCCFeature = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1.3]);

  return (
    <section ref={ref} className="relative overflow-hidden py-28 md:py-44" data-testid="gcc-section">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={IMAGES.gcc} alt="Aerial view of a modern GCC business district at dusk" className="w-full h-full object-cover" />
      </motion.div>
      <div className="absolute inset-0 bg-[#0b0b0b]/72" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <SectionLabel dark>Regional Reach</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-white">
            Connecting Talent With Opportunity Across the <span className="text-[#E03535]">GCC.</span>
          </h2>
          <p className="font-body text-white/70 text-lg leading-relaxed mt-8">
            From growing businesses to established enterprises, Prospera Staffing supports organizations
            building stronger teams in one of the world&apos;s most dynamic business regions.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={viewportOnce}
          transition={{ duration: 0.8 }}
          className="flex flex-wrap gap-x-10 gap-y-4 mt-14"
        >
          {LOCATIONS.map((loc) => (
            <div key={loc} className="flex items-center gap-3" data-testid={`location-${loc.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className="h-px w-8 bg-[#E03535]" />
              <span className="font-accent uppercase tracking-widest text-sm text-white">{loc}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default GCCFeature;
